module.exports = __webpack_public_path__ + "static/media/dashboard-dummy-image.2d176576.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/dashboard-dummy-image.svg
// module id = 490
// module chunks = 5